import { memo } from 'react';

interface IPdf {
  file: string | null;
  title?: string;
}

export const Pdf = memo(({ file, title }: IPdf) => {
  if (!file) return null;

  return (
    <div className='h-screen w-full'>
      <iframe src={file} title={title} className='h-full w-full' frameBorder={0} />
    </div>
  );
});

Pdf.displayName = 'Pdf';
